import Vue from "vue";

/**
 * Class SMS Service
 */
export default class SmsService extends Vue {
  private customActions = {
    sendSms: { method: 'POST', url: 'integration/sms/send-message' }
  };
  private resource: any = this.$resource(
    "integration/sms",
    {},
    this.customActions
  );

  public async sendSms(contact: any, message: string) {
    contact.message = message;
    return await this.resource.sendSms({}, contact);
}
}
